import { operationTypeEnum } from './operation-type';
import { OperationList } from './operationList';
import { SigTypes } from './sigTypes';

export const sigTypes: { [key: string]: SigTypes } = {
    [operationTypeEnum.SIG]: { id: operationTypeEnum.SIG, label: 'newcircuit_btn_sign_con_certificado', icon: '' },
    [operationTypeEnum.RVDOTP]: { id: operationTypeEnum.RVDOTP, label: 'newcircuit_btn_sign_sms', icon: '' },
    [operationTypeEnum.ACEP]: { id: operationTypeEnum.ACEP, label: 'newcircuit_btn_sign_simple', icon: '' },
    [operationTypeEnum.SIGBIO]: { id: operationTypeEnum.SIGBIO, label: 'newcircuit_btn_sign_bio', icon: '' },
    [operationTypeEnum.SIGQSCD]: { id: operationTypeEnum.SIGQSCD, label: 'newcircuit_btn_sign_con_certificado_cualificado', icon: '' }
};

export const profileList: { [key: number]: string } = {
    1: 'SYSADMIN',
    2: 'USER',
    3: 'SUPERADMIN',
    4: 'ADMIN',
    5: 'CONFIGURATOR'
};

export const rolesList: { [key: number]: string } = {
    1: 'MANAGER',
    2: 'READER',
    3: 'EMPLOYEE',
};

export const operationList: { [key: string]: OperationList } = {
    [operationTypeEnum.ACEP]: { icon: 'gesture', label: 'newcircuit_btn_sign_simple', template: true },
    [operationTypeEnum.DWN]: { icon: 'forward_to_inbox', label: 'newcircuit_btn_sign_certificado', template: true },
    [operationTypeEnum.RVDOTP]: { icon: 'phonelink_lock', label: 'newcircuit_btn_sign_sms', template: true },
    [operationTypeEnum.SIG]: { icon: 'verified_user', label: 'newcircuit_btn_sign_con_certificado', template: true },
    [operationTypeEnum.VAL]: { icon: 'check', label: 'newcircuit_btn_sign_validacion', template: true },
    [operationTypeEnum.NOTE]: { icon: 'notifications', label: 'newcircuit_btn_sign_note', template: true },
    [operationTypeEnum.SIGBIO]: { icon: 'fingerprint', label: 'newcircuit_btn_sign_bio', template: true },
    [operationTypeEnum.NOTI]: { icon: 'notifications', label: 'newcircuit_btn_sign_bell' },
    [operationTypeEnum.SIGAUT]: { icon: '', label: 'newcircuit_btn_sign_con_certificado_aut' },
    [operationTypeEnum.SIGORGA]: { icon: '', label: 'newcircuit_btn_sign_aut', template: true },
    [operationTypeEnum.DYNSIG]: { icon: 'assignment', label: 'newcircuit_btn_dynsig', template: true },
    [operationTypeEnum.QERDS]: { icon: 'notifications', label: 'newcircuit_btn_sign_qerds', template: true },
    [operationTypeEnum.SMSCERT]: { icon: 'lock', label: 'newcircuit_btn_sign_smscert', template: true },
    [operationTypeEnum.STOP]: { icon: '', label: '', template: true },
    [operationTypeEnum.SIGQSCD]: { icon: 'verified_user', label: 'newcircuit_btn_sign_con_certificado_cualificado', template: true }
};
export const emailRegex = '^([A-Z|a-z|0-9|\\.|_|\\-|\\+])+\\@([A-Z|a-z|0-9|\\.|\\-|\\+])+((\\.)+[A-Z|a-z]{2,20})+$';
export const phoneRegex = '^([0-9]){8,}$';
export const fullPhoneRegex = '^(\\+)?([0-9]){8,}$';
export const otpRegex = '^([0-9]){8}$';
export const phoneOrMailRegex = '^' + emailRegex.substring(1, emailRegex.length - 1) + '|' + fullPhoneRegex.substring(1, fullPhoneRegex.length - 1) + '$';

export const LOGIN_LOGO = 'assets/images/logo-login.png';
